import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export const RightArrowIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={applyDataTestId(pom.icons.rightArrowIcon)}
    >
      <title>Right Arrow</title>
      <path
        d="M5 12H20M20 12L13 19M20 12L13 5"
        stroke="#1F2A37"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
